const options = {
  5: "bg-teal-700/5",
  10: "bg-teal-700/10",
  25: "bg-teal-700/25",
  50: "bg-teal-700/50",
  75: "bg-teal-700/75",
  90: "bg-teal-700/90",
  100: "bg-teal-700",
};

const from = {
  5: "from-teal-700/5",
  10: "from-teal-700/10",
  25: "from-teal-700/25",
  50: "from-teal-700/50",
  75: "from-teal-700/75",
  90: "from-teal-700/90",
  100: "from-teal-700",
};

export default function getBackgroundTeal700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
